import script from "./PostTo.vue?vue&type=script&setup=true&lang=js"
export * from "./PostTo.vue?vue&type=script&setup=true&lang=js"

import "./PostTo.vue?vue&type=style&index=0&id=5590b63c&lang=scss"

const __exports__ = script;

export default __exports__